import React, { useContext } from 'react';
import Container from 'react-bootstrap/Container';
import moment from 'moment';

import PrivacyPolicyLink from '../policies/PrivacyPolicyLink';

import LocalizationContext from '../../context/LocalizationContext';
import { Audience } from '../../utils/types';
import { isAudience, isInternal } from '../../utils/InternalUtils';

import './Footer.css';

/**
 * Common react component that displays content at the bottom of the page. Typically for legal
 * statements.
 */
const Footer = () => {
    const localizedStrings = useContext(LocalizationContext);

    // No need to display the footer if our audience is our own corporation.
    if (isAudience(Audience.CORPORATE_EVENT)) {
        return null;
    }

    // Create the terms of use sub-components if applicable.
    // If 'termsOfUseUrl' is an empty string, skip the sub-component.
    const termsOfUse =
        localizedStrings.footer.termsOfUseUrl.length === 0 ? null : (
            <>
                <FooterLinkDivider />
                <a
                    href={localizedStrings.footer.termsOfUseUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {localizedStrings.footer.termsOfUse}
                </a>
            </>
        );

    // Render!
    return (
        <footer className="footer border-top d-flex" role="contentinfo" data-testid="app-footer">
            <Container>
                <p className="text-muted disclaimer-text">
                    <span>
                        {localizedStrings.formatString(
                            localizedStrings.footer.disclaimer,
                            moment().format('YYYY'),
                        )}
                    </span>
                    &nbsp;
                    <PrivacyPolicyLink isInternal={isInternal(localizedStrings)} />
                    {termsOfUse}
                </p>
            </Container>
        </footer>
    );
};

/**
 * Sub-component function for rendering the vertical pipe that divides the Privacy
 * Policy link and the Terms of Use link.
 */
const FooterLinkDivider = () => {
    const localization = useContext(LocalizationContext);
    if (localization.footer.termsOfUse) {
        return (
            <>
                &nbsp;<span className="break">|</span>&nbsp;
            </>
        );
    }
    return null;
};

export default Footer;
